export const teamTranslation = {
  en: {
    teams: "Teams",
    home: "Home",
    teamTitle: "Team Title",
    description: "Description",
    creationDate: "Creation Date",
    members: "Members",
    status: "Status",
    actions: "Actions",
    editTeam: "Edit Team",
    addNewTeam: "Add New Team",
    updateTeam: "Update Team",
    addTeam: "Add Team",
    searchByName: "Search by name...",
    addTeamButton: "+ Add Team",
    edit: "Edit",
    delete: "Delete",
    areYouSureDelete: "Are you sure you want to delete",
    thisActionCannotBeUndone: "This action cannot be undone.",
    selectUser: "Select User",
    createdBy: "Created By",
    teamName: "Team Name",
    cancel: "Cancel",
    teamOwner: "Team Owner",
    "Choose date range for teams": "Choose date range for teams",
    assignMembersToTeam: "Assign Members to Team",
    selectMembers: "Select Members",
  },
  ar: {
    teams: "الفرق",
    home: "الصفحة الرئيسية",
    teamTitle: "عنوان الفريق",
    description: "الوصف",
    creationDate: "تاريخ الإنشاء",
    members: "الأعضاء",
    status: "الحالة",
    actions: "الإجراءات",
    editTeam: "تعديل الفريق",
    addNewTeam: "إضافة فريق جديد",
    updateTeam: "تحديث الفريق",
    addTeam: "إضافة فريق",
    searchByName: "البحث حسب الاسم...",
    addTeamButton: "+ إضافة فريق",
    edit: "تعديل",
    delete: "حذف",
    areYouSureDelete: "هل أنت متأكد أنك تريد حذف",
    thisActionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    selectUser: "اختر مستخدم",
    createdBy: "أنشأ بواسطة",
    teamName: "اسم الفريق",
    cancel: "إلغاء",
    teamOwner: "مالك الفريق",
    "Choose date range for teams": "اختر نطاق التاريخ للفرق",
    assignMembersToTeam: "تعيين أعضاء للفريق",
    selectMembers: "اختر الأعضاء",
  },
};
